type CalculateOffsetParams = {
  page: number
  limit: number
}

function calculateOffset({ page, limit }: CalculateOffsetParams) {
  return page * limit - limit
}

export { calculateOffset }
